/** Folders under public/app/locales/ — keep in sync with LanguageContext picker. */
export const SUPPORTED_LANGUAGE_CODES = [
  "bg", "cs", "da", "de", "el", "en", "es", "et", "fi", "fr", "ga", "hr", "hu",
  "id", "it", "lt", "lv", "mt", "nl", "pl", "pt", "ro", "sk", "sl", "sv",
];

const SUPPORTED_SET = new Set(SUPPORTED_LANGUAGE_CODES);

const LANGUAGE_ALIASES = {
  dk: "da",
  "da-dk": "da",
};

/** Map fr-FR → fr, dk → da; reject unknown API values so locale paths stay valid. */
export function normalizeLanguageCode(code) {
  if (code == null || typeof code !== "string") return null;
  const trimmed = code.trim().toLowerCase();
  if (!trimmed) return null;
  if (LANGUAGE_ALIASES[trimmed]) return LANGUAGE_ALIASES[trimmed];
  if (SUPPORTED_SET.has(trimmed)) return trimmed;
  const base = trimmed.split(/[-_]/)[0];
  if (LANGUAGE_ALIASES[base]) return LANGUAGE_ALIASES[base];
  if (SUPPORTED_SET.has(base)) return base;
  return null;
}
